import { render, staticRenderFns } from "./permissionMatrixCell.vue?vue&type=template&id=4966788a&scoped=true&"
import script from "./permissionMatrixCell.vue?vue&type=script&lang=js&"
export * from "./permissionMatrixCell.vue?vue&type=script&lang=js&"
import style0 from "./permissionMatrixCell.vue?vue&type=style&index=0&id=4966788a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4966788a",
  null
  
)

export default component.exports